import { Link } from "react-router-dom";
import { Globe } from "@phosphor-icons/react";
import { logoUrl, useSettings } from "@/lib/settings";
import MapleLeaf from "./MapleLeaf";

export default function BrandMark({ size = "md", variant = "dark", testid = "brandmark" }) {
  const settings = useSettings();
  const logo = logoUrl(settings);
  const DIM_MAP = { lg: 40, sm: 28, md: 32 };
  const LOGO_H_MAP = { lg: 56, sm: 36, md: 48 };
  const dim = DIM_MAP[size] ?? DIM_MAP.md;
  // Uploaded brand logos render larger than the wordmark fallback so they're easy to spot.
  const logoH = LOGO_H_MAP[size] ?? LOGO_H_MAP.md;
  const isLight = variant === "light"; // for dark backgrounds (footer/cta)

  return (
    <Link to="/" data-testid={testid} className="flex items-center gap-2 group shrink-0">
      {logo ? (
        <img src={logo} alt={settings.brand_name} style={{ height: logoH }} className="object-contain drop-shadow-sm" />
      ) : (
        <>
          <span
            className="relative flex items-center justify-center"
            style={{
              width: dim, height: dim,
              background: isLight ? "#C8A97E" : "#0A2540",
            }}
          >
            <Globe size={Math.round(dim * 0.55)} weight="duotone" color={isLight ? "#0A2540" : "#C8A97E"} />
            <MapleLeaf
              size={Math.round(dim * 0.32)}
              color={isLight ? "#0A2540" : "#B8333D"}
              className="absolute -top-1 -right-1 drop-shadow"
            />
          </span>
          <div className="leading-tight">
            <div className={`font-display ${size === "lg" ? "text-xl" : "text-lg"} ${isLight ? "text-white" : "text-gos-navy"} tracking-tight`}>
              {settings.brand_name?.split(" ")[0] || "Open"} {settings.brand_name?.split(" ").slice(1).join(" ") || ""}
            </div>
          </div>
        </>
      )}
    </Link>
  );
}
